<div class="flex flex-col gap-6 h-full">
  <div class="flex flex-row justify-end items-center" selected="table">
    <mat-button-toggle-group #group="matButtonToggleGroup">
      <mat-button-toggle value="table">
        <mat-icon>grid_on</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="calendar">
        <mat-icon>today</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="flex flex-1 flex-row gap-2">
    <div [ngClass]="{'md:flex hidden':selectedDelivery, 'flex-1 flex flex-col min-w-0':true}">
      <ag-grid-angular *ngIf="group.value === 'table'" #agGrid [ngStyle]="{ 'height.px': height }"
        class="basis-full flex-none ag-theme-alpine" [headerHeight]="45" (onGridReady)="setRowData()"
        (rowSelected)="selectRow($event)" [columnDefs]="columns" enableColResize enableSorting enableFilter
        rowSelection="single"></ag-grid-angular>
      <div *ngIf="group.value === 'calendar'" class="basis-full flex-none flex flex-col">
        @if (calendarItems.length) {
        <!-- Calendar controls row -->
        <div class="flex flex-row mt-3 mb-3">
          <div class="basis-[35%] flex-none flex flex-row items-center">
            <button mat-icon-button (click)="changeViewDate(-1)">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button (click)="changeViewDate(0)" mat-button>Today</button>
            <button (click)="changeViewDate(1)" mat-icon-button>
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
          <div class="basis-[30%] flex-none">
            <h3 *ngIf="calendarViewType === 'week'" class="text-center">
              Week {{ calendarViewDateMoment.format('w') }}
            </h3>
            <h3 *ngIf="calendarViewType === 'month'" class="text-center">
              {{ calendarViewDateMoment.format('MMMM') }}
            </h3>
            <h3 *ngIf="calendarViewType === 'day'" class="text-center">
              {{ calendarViewDateMoment.format('ddd D MMM YY') }}
            </h3>
          </div>
          <div class="basis-[35%] flex-none flex flex-row justify-end items-center">
            <button mat-button (click)="changeCalendarView('month')">
              Month
            </button>
            <button mat-button (click)="changeCalendarView('week')">
              Week
            </button>
            <button mat-button (click)="changeCalendarView('day')">
              Day
            </button>
          </div>
        </div>

        <!-- Calendar view -->
        <div [ngSwitch]="calendarViewType" class="flex-1 flex flex-col">
          <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="calendarViewDate" [events]="calendarItems"
            [refresh]="refresh" [activeDayIsOpen]="false" (eventClicked)="selectDelivery($event)">
          </mwl-calendar-month-view>
          <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="calendarViewDate" [events]="calendarItems"
            class="basis-full" [refresh]="refresh" [dayEndHour]="18" [dayStartHour]="7" [hourSegments]="1"
            [hourSegmentHeight]="45" (eventClicked)="selectDelivery($event)">
          </mwl-calendar-week-view>
          <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="calendarViewDate" [events]="calendarItems"
            [refresh]="refresh" [dayStartHour]="7" [dayEndHour]="18" (eventClicked)="selectDelivery($event)">
          </mwl-calendar-day-view>
        </div>
        } @else {
        <div class="flex flex-row justify-center items-center">
          <p>No bookings to show.</p>
        </div>
        }
      </div>
    </div>
    <div class="md:basis-1/3 flex-shrink-0 basis-full flex-none flex flex-col pl-4 pr-4 mat-elevation-z4"
      [class.md\:basis-full]="!selectedDelivery" *ngIf="selectedDelivery" id="delivery-detail-container">
      <app-delivery-job-details [jobId]="selectedDelivery.id" (close)="deselect()"></app-delivery-job-details>
    </div>
  </div>
</div>